export default class GlobalRefs {
    loginPopUpUi = undefined;
    createEditEventUi = undefined;
    isLoggedIn: boolean = localStorage.userMetadata != null;

    constructor() {}
}
